module.exports = __webpack_public_path__ + "static/media/overlaybg.17976947.png";